"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
function createConfig() {
    var config = {
        chainId: 1,
    };
    return {
        set: function (key, value) { return (config[key] = value); },
        get: function (key) { return config[key]; },
    };
}
exports.config = createConfig();
